import React from 'react';

import Heading from '@atlaskit/heading';
import { Inline } from '@atlaskit/primitives/compiled';

import type { PreviewPanelTitleProps } from './types';

export const PreviewPanelTitle = ({ title, Icon }: PreviewPanelTitleProps) => {
	return (
		<Inline space="space.050" alignBlock="center">
			{Icon && <Icon label="" spacing="spacious" size="small" appearance="brand" />}
			<Heading size="xsmall">{title}</Heading>
		</Inline>
	);
};
